import { render, staticRenderFns } from "./DialogPackageList.vue?vue&type=template&id=dd3ead7a"
import script from "./DialogPackageList.vue?vue&type=script&lang=js"
export * from "./DialogPackageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports